import {StoreType} from '..';
//types
import {IEventTodoList, IOrganizationEvent, IOrganizationSponsorCategoryResponse} from '../../utils/types';

export const getEventsLoadingSelector = (state: StoreType): boolean => state.organizationEventStore.isLoading;

export const getEventsSelector = (state: StoreType): IOrganizationEvent[] | null => state.organizationEventStore.events;

export const getCurrentEventSelector = (state: StoreType): IOrganizationEvent | null =>
	state.organizationEventStore.currentEvent;

export const getSponsorCategoriesSelector = (state: StoreType): IOrganizationSponsorCategoryResponse[] | null =>
	state.organizationEventStore.sponsorCategories;

export const getEventTotoListSelector = (state: StoreType): IEventTodoList[] => state.organizationEventStore.todoList;
